import {coerceToString} from "./coerceToString";

export function sortArrayOfObjects(array, key) {
    // sorts an array of objects based on their value for the specific key.
    return array.sort(function(a, b) {
        const x = coerceToString(a[key]).toUpperCase();
        const y = coerceToString(b[key]).toUpperCase();
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}
